import { render, staticRenderFns } from "./agv-customer-balance.vue?vue&type=template&id=1cbaa44b&scoped=true&lang=pug&"
import script from "./agv-customer-balance.vue?vue&type=script&lang=js&"
export * from "./agv-customer-balance.vue?vue&type=script&lang=js&"
import style0 from "./agv-customer-balance.vue?vue&type=style&index=0&id=1cbaa44b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbaa44b",
  null
  
)

export default component.exports